import React from 'react';
import '../template-file-css/document-file-template.css';


export const NWBH_BriefBehavioralHealth = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='NWBH_BriefBehavioralHealth' className='file-pdf-document'>
            <div className='file-template'>


                <p className='w-750'><h3>Brief Behavioral Health Assessment</h3></p>
                <p className='w-750'><h4>Section A: Clinical Summary</h4></p>


                <table>
                    <tr>
                        <td className='w-450'><span className='eleHeader'>Historical Factors</span></td>

                        <td className='w-100'><span className='eleHeader'>Yes</span></td>

                        <td className='w-100'><span className='eleHeader'>No</span></td>

                        <td className='w-100'><span className='eleHeader'>Not Known</span></td>
                    </tr>


                    <tr>
                        <td className='w-450'>History of Violent or Inappropriate Behavior</td>
                        <td className='w-100'>
                            <input type='radio' id='rbHistorical_Yes' name='rbHistorical' className='add-only' value='1' />
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbHistorical_No' name='rbHistorical' className='add-only' value='2' />
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbHistorical_Ni' name='rbHistorical' className='add-only' value='3' />
                        </td>
                    </tr>


                    <tr>
                        <td className='w-450'>Criminal History</td>

                        <td className='w-100'>
                            <input type='radio' id='rbHistorical1_Yes' name='rbHistorical1' className='add-only' value='1' />
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbHistorical1_No' name='rbHistorical1' className='add-only' value='2' />
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbHistorical1_Ni' name='rbHistorical1' className='add-only' value='3' />
                        </td>
                    </tr>


                    <tr>
                        <td className='w-450'>Family History of Mental Health Problems</td>

                        <td className='w-100'>
                            <input type='radio' id='rbHistorical2_Yes' name='rbHistorical2' className='add-only' value='1' />
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbHistorical2_No' name='rbHistorical2' className='add-only' value='2' />
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbHistorical2_Ni' name='rbHistorical2' className='add-only' value='3' />
                        </td>
                    </tr>


                    <tr>
                        <td className='w-450'>History of Abuse and /or Neglect</td>

                        <td className='w-100'>
                            <input type='radio' id='rbHistorical3_Yes' name='rbHistorical3' className='add-only' value='1' />
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbHistorical3_No' name='rbHistorical3' className='add-only' value='2' />
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbHistorical3_Ni' name='rbHistorical3' className='add-only' value='3' />
                        </td>
                    </tr>


                    <tr>
                        <td className='w-450'>History of Substance Abuse or Misuse</td>

                        <td className='w-100'>
                            <input type='radio' id='rbHistorical4_Yes' name='rbHistorical4' className='add-only' value='1' />
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbHistorical4_No' name='rbHistorical4' className='add-only' value='2' />
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbHistorical4_Ni' name='rbHistorical4' className='add-only' value='3' />
                        </td>
                    </tr>


                    <tr>
                        <td className='w-450'>History of Depression</td>

                        <td className='w-100'>
                            <input type='radio' id='rbHistorical5_Yes' name='rbHistorical5' className='add-only' value='1' />
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbHistorical5_No' name='rbHistorical5' className='add-only' value='2' />
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbHistorical5_Ni' name='rbHistorical5' className='add-only' value='3' />
                        </td>
                    </tr>


                    <tr>
                        <td className='w-450'>History of Psychiatric Hospitalizations</td>

                        <td className='w-100'>
                            <input type='radio' id='rbHistorical6_Yes' name='rbHistorical6' className='add-only' value='1' />
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbHistorical6_No' name='rbHistorical6' className='add-only' value='2' />
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbHistorical6_Ni' name='rbHistorical6' className='add-only' value='3' />
                        </td>
                    </tr>


                    <tr>
                        <td className='w-450'>Lack of Family of Social Support</td>

                        <td className='w-100'>
                            <input type='radio' id='rbHistorical7_Yes' name='rbHistorical7' className='add-only' value='1' />
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbHistorical7_No' name='rbHistorical7' className='add-only' value='2' />
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbHistorical7_Ni' name='rbHistorical7' className='add-only' value='3' />
                        </td>
                    </tr>


                    <tr>
                        <td className='w-450'>History of Medical Non-compliance</td>

                        <td className='w-100'>
                            <input type='radio' id='rbHistorical8_Yes' name='rbHistorical8' className='add-only' value='1' />
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbHistorical8_No' name='rbHistorical8' className='add-only' value='2' />
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbHistorical8_Ni' name='rbHistorical8' className='add-only' value='3' />
                        </td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-450'>
                            <span className='eleHeader'>Current Risk Factor</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>Yes</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>No</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>Not Known</span>
                        </td>
                    </tr>


                    <tr>
                        <td className='w-450'>Express Intent to Harm Self or Others</td><td className='w-100'>
                            
                            <input type='radio' id='rbCurrentRisk_Yes' name='rbCurrentRisk' className='add-only' value='1' />
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbCurrentRisk_No' name='rbCurrentRisk' className='add-only' value='2' />
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbCurrentRisk_Ni' name='rbCurrentRisk' className='add-only' value='3' />
                        </td>
                    </tr>


                    <tr>
                        <td className='w-450'>Criminal Involvement</td>

                        <td className='w-100'>
                            <input type='radio' id='rbCurrentRisk1_Yes' name='rbCurrentRisk1' className='add-only' value='1' />
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbCurrentRisk1_No' name='rbCurrentRisk1' className='add-only' value='2' />
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbCurrentRisk1_Ni' name='rbCurrentRisk1' className='add-only' value='3' />
                        </td>
                    </tr>


                    <tr>
                        <td className='w-450'>Paranoid ideations</td>

                        <td className='w-100'>
                            <input type='radio' id='rbCurrentRisk2_Yes' name='rbCurrentRisk2' className='add-only' value='1' />
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbCurrentRisk2_No' name='rbCurrentRisk2' className='add-only' value='2' />
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbCurrentRisk2_Ni' name='rbCurrentRisk2' className='add-only' value='3' />
                        </td>
                    </tr>


                    <tr>
                        <td className='w-450'>Violent Commands or Preoccupation with Violence</td>

                        <td className='w-100'>
                            <input type='radio' id='rbCurrentRisk3_Yes' name='rbCurrentRisk3' className='add-only' value='1' />
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbCurrentRisk3_No' name='rbCurrentRisk3' className='add-only' value='2' />
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbCurrentRisk3_Ni' name='rbCurrentRisk3' className='add-only' value='3' />
                        </td>
                    </tr>


                    <tr>
                        <td className='w-450'>Current Misuse of Drugs/Alcohol</td>

                        <td className='w-100'>
                            <input type='radio' id='rbCurrentRisk4_Yes' name='rbCurrentRisk4' className='add-only' value='1' />
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbCurrentRisk4_No' name='rbCurrentRisk4' className='add-only' value='2' />
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbCurrentRisk4_Ni' name='rbCurrentRisk4' className='add-only' value='3' />
                        </td>
                    </tr>


                    <tr>
                        <td className='w-450'>Functional impairment</td>

                        <td className='w-100'>
                            <input type='radio' id='rbCurrentRisk5_Yes' name='rbCurrentRisk5' className='add-only' value='1' />
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbCurrentRisk5_No' name='rbCurrentRisk5' className='add-only' value='2' />
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbCurrentRisk5_Ni' name='rbCurrentRisk5' className='add-only' value='3' />
                        </td>
                    </tr>


                    <tr>
                        <td className='w-450'>Inappropriate Sexual Behavior</td>

                        <td className='w-100'>
                            <input type='radio' id='rbCurrentRisk6_Yes' name='rbCurrentRisk6' className='add-only' value='1' />
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbCurrentRisk6_No' name='rbCurrentRisk6' className='add-only' value='2' />
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbCurrentRisk6_Ni' name='rbCurrentRisk6' className='add-only' value='3' />
                        </td>
                    </tr>


                    <tr>
                        <td className='w-450'>Bizarre or Delusional Behavior</td>

                        <td className='w-100'>
                            <input type='radio' id='rbCurrentRisk7_Yes' name='rbCurrentRisk7' className='add-only' value='1' />
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbCurrentRisk7_No' name='rbCurrentRisk7' className='add-only' value='2' />
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbCurrentRisk7_Ni' name='rbCurrentRisk7' className='add-only' value='3' />
                        </td>
                    </tr>


                    <tr>
                        <td className='w-450'>Lack Self Control or Self Esteem</td>

                        <td className='w-100'>
                            <input type='radio' id='rbCurrentRisk8_Yes' name='rbCurrentRisk8' className='add-only' value='1' />
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbCurrentRisk8_No' name='rbCurrentRisk8' className='add-only' value='2' />
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbCurrentRisk8_Ni' name='rbCurrentRisk8' className='add-only' value='3' />
                        </td>
                    </tr>
                </table>


                <p className='w-750'>
                    <input type='checkbox' name='chkReferralVision' id='chkReferralVision' className='add-only' value='1' />
                    The recipient has a mental health diagnosis that meets the medically necessity criteria for treatment as recommended in Section C.
                </p>
                <p>
                    And
                </p>
                <p>
                    <input type='checkbox' name='chkReferralVision1' id='chkReferralVision1' className='add-only' value='1' />
                    There is adequate evidence to indicate that the condition of the recipient cannot improve with less intensive services
                </p>
                <p>
                    Or
                </p>
                <p>
                    <input type='checkbox' name='chkReferralVision2' id='chkReferralVision2' className='add-only' value='1' />The recipient does not meet diagnostic criteria and is not eligible for community mental health services
                </p>
                <p>
                    <strong>Section B: Diagnostic Impression</strong>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>AXIS I:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtDiagnostic' name='txtDiagnostic' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p>
                    <strong>Section C: Recommendations</strong>
                </p>
                <p>
                    I have competed brief face to face behavioral health screening and I concur with the following recommendations for treatment intervention
                </p>
                <table>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' name='chkIndividual' id='chkIndividual' className='add-only' value='1' />Individual Therapy
                        </td>

                        <td className='w-187'>
                            <input type='checkbox' name='chkIndividual2' id='chkIndividual2' className='add-only' value='1' />Group/Family Therapy
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='chkIndividual3' id='chkIndividual3' className='add-only' value='1' />Psychiatric Services
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='chkIndividual5' id='chkIndividual5' className='add-only' value='1' />Supportive Living
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' name='chkIndividual1' id='chkIndividual1' className='add-only' value='1' />Psychosocial Rehabilitative Services
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' name='chkIndividual4' id='chkIndividual4' className='add-only' value='1' />Co-occurring Outpatient Treatment
                        </td>

                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' name='chkIndividual6' id='chkIndividual6' className='add-only' value='1' />Substance Abuse Outpatient
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' name='chkIndividual7' id='chkIndividual7' className='add-only' value='1' />Other : &nbsp;
                            <input type='text' id='txtOther' name='txtOther' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

            </div>
        </form>

    )
}

